module.exports = __webpack_public_path__ + "media/images/emblems/Centovalli-coat_of_arms-078cb7fc7a7614a05a7b17d3a8fb2755.png";